import { generateSequentialArray } from "../../common/utils";
import {
  MovePageButton,
  PageButton,
  PaginationContainer,
} from "./PaginationStyles";

const DEFAULT_PAGES = 5;

function Pagination(props) {
  const { numPages, pageHook, onPageClick } = props;
  const [page, updatePage] = pageHook;

  const switchPage = (e) => {
    if (e.target.value === -1) return;
    updatePage(parseInt(e.target.value));
    if (onPageClick) onPageClick(parseInt(e.target.value));
  };

  const getShownPages = () => {
    const shownPages = [];

    if (numPages <= DEFAULT_PAGES + 2) {
      return generateSequentialArray(numPages);
    }

    shownPages.push(0);

    if (page < DEFAULT_PAGES - 1) {
      for (let i = 1; i < DEFAULT_PAGES; i++) {
        shownPages.push(i);
      }
      shownPages.push(-1);
    } else if (page > numPages - DEFAULT_PAGES) {
      shownPages.push(-1);
      for (let i = numPages - DEFAULT_PAGES; i < numPages - 1; i++) {
        shownPages.push(i);
      }
    } else {
      shownPages.push(-1);
      for (let i = page - 1; i <= page + 1; i++) {
        shownPages.push(i);
      }
      shownPages.push(-1);
    }

    shownPages.push(numPages - 1);
    return shownPages;
  };

  const populatePageButtons = () => {
    return getShownPages().map((value, index) => {
      return (
        <PageButton
          key={index}
          value={value}
          onClick={switchPage}
          activated={value === page}
        >
          {value === -1 ? "..." : value + 1}
        </PageButton>
      );
    });
  };

  return (
    <PaginationContainer>
      {numPages > 0 ? (
        <>
          <MovePageButton
            onClick={() => {
              updatePage(Math.max(0, page - 1));
              if (onPageClick) onPageClick(Math.max(0, page - 1));
            }}
          >
            Anterior
          </MovePageButton>
          <div>{populatePageButtons()}</div>
          <MovePageButton
            onClick={() => {
              updatePage(Math.min(numPages - 1, page + 1));
              if (onPageClick) onPageClick(Math.min(numPages - 1, page + 1));
            }}
          >
            Siguiente
          </MovePageButton>
        </>
      ) : null}
    </PaginationContainer>
  );
}

export default Pagination;
